import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';
import { useIntegratedBoloQueueViews } from '../bolos/bolo-queues/use-integrated-bolo-queue-views';
import { useApplicationType } from '../common/hooks/use-application-type';
import { useIntegratedEventQueueViews } from '../event-queues/use-integrated-event-queue-views';
import { useIntegratedUnitQueueViews } from '../unit-queues/use-integrated-unit-queue-views';

export function QueueViewsListeners() {
    const { queuesRearchitectureEnabled, viewBolos } = useEnabledFeatures();
    const { isFirstResponder } = useApplicationType();
    return (
        <>
            {(queuesRearchitectureEnabled || isFirstResponder) && <RearchitectedQueuesListeners />}
            {viewBolos && <BolosListener />}
        </>
    );
}

function RearchitectedQueuesListeners() {
    useIntegratedEventQueueViews();
    useIntegratedUnitQueueViews();
    return <></>;
}

function BolosListener() {
    useIntegratedBoloQueueViews();
    return <></>;
}
